/**
 * Verifica se una singola feature è abilitata nello stato.
 */
export const hasFeature = (license, featureKey) => {
  return license?.features?.[featureKey] === true;
};

/**
 * Verifica se **almeno una** tra più feature è abilitata.
 */
export const hasAnyFeature = (license, featureKeys) => {
  if (!Array.isArray(featureKeys)) {
    return false;
  }
  return featureKeys.some(key => hasFeature(license, key));
};

/**
 * Verifica se **tutte** le feature specificate sono abilitate.
 */
export const hasAllFeatures = (license, featureKeys) => {
  if (!Array.isArray(featureKeys)) {
    return false;
  }
  return featureKeys.every(key => hasFeature(license, key));
};
